<template>
    <div class="devices-list__block" v-if="deviceData" @click="openHeatingHistory">
        <device-status :device="deviceData" :showLocation="showLocation" :edit="edit"/>
        <v-layout row class="devices-list__block__title" :class="{'device-btns-edit': edit}">
            <device-title :device="deviceData"></device-title>
            <div class="btn-group">
                <v-flex class="btn-block" v-if="deviceData.state">
                    <div class="d-inline-flex" v-if="!!deviceData.state.heating">
                        <v-img max-height="30px" max-width="30px" :src="require('@/assets/icons/flame_icon.svg')" class="d-inline-flex"/>

                        <!--                        <v-switch-->
<!--                            v-model="deviceState"-->
<!--                            inset-->
<!--                            dense-->
<!--                            hide-details-->
<!--                            class="pa-0"-->
<!--                            @click="changeDeviceSwitch"-->
<!--                            :loading="loading"-->
<!--                            color="#FF8484"-->
<!--                            v-if="free"-->
<!--                        ></v-switch>-->
<!--                        <device-switch-disabled :device-state="deviceData.state" :name="deviceData.uid" v-else :not-free="!free" />-->
                    </div>
                    <div class="d-inline-flex" v-else>
                        <v-img max-height="30px" max-width="30px" :src="require('@/assets/icons/flame_disabled_icon.svg')" class="d-inline-flex"/>
                    </div>
                </v-flex>
            </div>
        </v-layout>
        <div class="main-text mt-3 mx-2" v-if="deviceData.state" @click.stop.prevent>
            <vue-slider
                v-model="deviceData.state.value"
                :data="values"
                :marks="tickLabels"
                :adsorb="true"
                :interval="1"
                :min="16"
                :max="28"
                :height="16"
                :lazy="true"
                :disabled="!free || deviceData.disabled"
                tooltip="none"
                class="vue-custom-slider"
                @change="changeDeviceSlider"
            />
        </div>
        <ModalHeatingHistory v-model="openModal" :history="history"></ModalHeatingHistory>
        <ModalWaiting ref="modalWaiting" title="Загрузка данных"></ModalWaiting>
    </div>
</template>

<script>
import ModalHeatingHistory from "@/components/modals/ModalHeatingHistory";
import ModalWaiting from "@/components/modals/ModalWaiting";
import { LOADING_TIMEOUT } from "@/utils/constants.js";

export default {
    name: "HeatingDevice",
    components: {ModalHeatingHistory, ModalWaiting},
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
        free: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
            deviceStateOldValue: null,
            deviceState: false,
            tickLabels: ['OFF', 18, 20, 22, 24, 26, 28],
            values: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28,],
            loading: false,
            history: [],
            openModal: false,
            disabledTimeout: null,
        };
    },
    created() {
        this.deviceData = JSON.parse(JSON.stringify(this.device));
        this.deviceState = this.deviceData.state ? this.deviceData.state.value ? true : false : false;
        this.deviceStateOldValue = JSON.parse(JSON.stringify(this.deviceData.state));
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = JSON.parse(JSON.stringify(val));
                this.loading = false;
                this.deviceState = this.deviceData.state ? this.deviceData.state.value ? true : false : false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
        "deviceData.state": {
            handler: function(val, old) {
                if (val != old && this.deviceData.state.value != this.deviceStateOldValue.value) {
                    this.deviceStateOldValue = old;
                }
            },
            deep: true,
        },
    },
    methods: {
        changeDeviceSwitch() {
            if (this.deviceState) {
                this.deviceData.state.value = 28;
            } else {
                this.deviceData.state.value = 17;
            }
            this.changeDeviceValue();
        },
        changeDeviceSlider() {
            setTimeout(() => {
                this.changeDeviceValue();
            }, 1000);
        },
        changeDeviceValue() {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.loading = false;
                this.deviceData.state = this.deviceStateOldValue;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/hotel-admin/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state.value > 17 ? this.deviceData.state.value : null
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.deviceData.state = this.deviceStateOldValue;
                    this.loading = false;
                    console.log(error);
                });
        },
        openHeatingHistory() {
            if (this.deviceData && this.deviceData.uid) {
                this.$refs.modalWaiting.open();
                this.$http.get('/devices/hotel-admin/heating-history/' + this.deviceData.uid + '/')
                    .then((response) => {
                        this.history = response.data.actions;
                        this.openModal = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$refs.modalWaiting.close();
                    });
            }
        },
    },
}
</script>
